/* ==========================================================================
   Bundle PDP FAQ — the accordion's motion.

   Progressive enhancement over <details>/<summary>, which already opens,
   closes and announces itself correctly on its own. This file adds two
   things and nothing else:

   * a height animation, since a native <details> snaps open with no
     in-between;
   * closing the other rows as one opens, when the section setting asks for
     it. Without JavaScript every row simply opens independently, which is a
     perfectly reasonable FAQ.

   The animation runs on the Web Animations API rather than a CSS transition,
   so a half-finished open can be cancelled cleanly by the next click and the
   panel is never left with a stale inline height.
   ========================================================================== */
(function () {
  'use strict';

  var DURATION = 280;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function animateHeight(row, from, to, onDone) {
    if (row.anim) {
      row.anim.cancel();
      row.anim = null;
    }

    if (prefersReducedMotion() || typeof row.panel.animate !== 'function') {
      onDone();
      return;
    }

    row.anim = row.panel.animate(
      [{ height: from + 'px' }, { height: to + 'px' }],
      { duration: DURATION, easing: EASING }
    );

    // Nothing is left behind on the element: the animation only borrows the
    // height for its run, so an open panel goes back to sizing itself.
    row.anim.onfinish = function () {
      row.anim = null;
      onDone();
    };
  }

  function openRow(row) {
    // The panel is not rendered while the row is shut, so it has to be opened
    // before its full height can be measured.
    row.details.open = true;
    animateHeight(row, 0, row.panel.scrollHeight, function () {});
  }

  function closeRow(row) {
    if (!row.details.open) return;

    animateHeight(row, row.panel.offsetHeight, 0, function () {
      row.details.open = false;
    });
  }

  function setup(section) {
    var single = section.dataset.single === 'true';

    var rows = Array.prototype.map
      .call(section.querySelectorAll('.bundle-faq__row'), function (details) {
        return {
          details: details,
          summary: details.querySelector('.bundle-faq__question'),
          panel: details.querySelector('.bundle-faq__panel'),
          anim: null
        };
      })
      // A question with no answer has nothing to animate; the browser's own
      // toggle is left alone for it.
      .filter(function (row) {
        return row.summary && row.panel;
      });

    rows.forEach(function (row) {
      row.summary.addEventListener('click', function (event) {
        event.preventDefault();

        if (row.details.open) {
          closeRow(row);
          return;
        }

        if (single) {
          rows.forEach(function (other) {
            if (other !== row) closeRow(other);
          });
        }

        openRow(row);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-bundle-faq]').forEach(function (section) {
      if (section.dataset.faqReady === 'true') return;
      section.dataset.faqReady = 'true';
      setup(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
